import { storyblokEditable } from "@storyblok/react";

const Card = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display ">
      <div className="card">
        <div className="card-image">
          {/* <div className="icon-svg">{blok.icon}</div> */}
          <img src={blok.cardimage.filename} alt={blok.cardimage.alt} />
        </div>
        <div className="card-detail">
          <p className="preamble">{blok.preamble}</p>
          <h3>{blok.title}</h3>
          <p className="desc">{blok.description}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
